declare global {
  interface Window {
    _upservice: any;
  }
}
export const supportChatStyles = "spj4edr";

require("./supportChatStyles.linaria.module.css!=!../../../node_modules/linaria/node_modules/@linaria/webpack4-loader/lib/outputCssLoader.js?cacheProvider=!./supportChatStyles.ts");